import { FC } from 'react';
import { CircleButton } from 'vopay';
import type { ComponentProps } from 'react';

type CircleButtonProps = ComponentProps<typeof CircleButton>;

type CopyButtonProps = {
  content: string | number;
  size?: CircleButtonProps['size'];
  colorScheme?: CircleButtonProps['colorScheme'];
};

const CopyButton: FC<CopyButtonProps> = ({ content, size = 'medium', colorScheme = 'action' }) => (
  <CircleButton
    icon="content_copy"
    size={size}
    colorScheme={colorScheme}
    onClick={() => {
      navigator.clipboard.writeText(content.toString());
    }}
  />
);

export default CopyButton;
